export default "__VITE_ASSET__BKBYkZVI__"